import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import { SkyviewPage } from '../pages/skyview/skyview-page';

const SkyviewRoute = () => {
  const { projectId } = useParams();
  const [searchParams] = useSearchParams();

  return (
    <SkyviewPage
      assetMenuVisible={searchParams.get('assetMenuVisible') !== 'false'}
      projectId={projectId!}
    />
  );
};

export { SkyviewRoute };
